/* CARAVIUM COPILOT VOICE INPUT V1 */
(() => {
  'use strict';

  const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!Recognition) return;

  const styleId = 'cv-copilot-voice-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .cv-copilot-question__form{align-items:center}
      .cv-copilot-voice{
        flex:0 0 auto;
        width:42px;
        height:42px;
        border:0;
        border-radius:12px;
        display:inline-flex;
        align-items:center;
        justify-content:center;
        background:#eef7f6;
        color:#087f75;
        cursor:pointer;
        font-size:20px;
        line-height:1;
        transition:.18s ease;
      }
      .cv-copilot-voice:hover{background:#ddf3ef}
      .cv-copilot-voice.is-listening{
        background:#16b8a6;
        color:#fff;
        box-shadow:0 0 0 5px rgba(22,184,166,.16);
        animation:cvVoicePulse 1s infinite alternate;
      }
      .cv-copilot-voice-status{
        margin-top:7px;
        font-size:12px;
        color:rgba(255,255,255,.78);
        min-height:16px;
      }
      @keyframes cvVoicePulse{
        to{transform:scale(.96);box-shadow:0 0 0 8px rgba(22,184,166,.08)}
      }
      @media(max-width:520px){
        .cv-copilot-question__form{display:grid;grid-template-columns:1fr 46px}
        .cv-copilot-question__input{grid-column:1/2}
        .cv-copilot-voice{grid-column:2/3;grid-row:1}
        .cv-copilot-question__submit{grid-column:1/3}
      }
    `;
    document.head.appendChild(style);
  }

  function install(root) {
    if (!root || root.dataset.cvVoiceReady === '1') return;

    const form = root.querySelector('#cv-copilot-question-form');
    const input = root.querySelector('#cv-copilot-question-input');
    const submit = root.querySelector('.cv-copilot-question__submit');
    if (!form || !input || !submit) return;

    root.dataset.cvVoiceReady = '1';

    const mic = document.createElement('button');
    mic.type = 'button';
    mic.className = 'cv-copilot-voice';
    mic.setAttribute('aria-label', 'Preguntar por voz');
    mic.setAttribute('title', 'Preguntar por voz');
    mic.innerHTML = '🎙️';
    form.insertBefore(mic, submit);

    const status = document.createElement('div');
    status.className = 'cv-copilot-voice-status';
    status.setAttribute('aria-live', 'polite');
    form.insertAdjacentElement('afterend', status);

    const recognition = new Recognition();
    recognition.lang = 'es-ES';
    recognition.continuous = false;
    recognition.interimResults = true;
    recognition.maxAlternatives = 1;

    let listening = false;
    let finalText = '';

    const setListening = (value) => {
      listening = value;
      mic.classList.toggle('is-listening', value);
      mic.setAttribute('aria-pressed', value ? 'true' : 'false');
      status.textContent = value ? 'Escuchando… habla ahora' : '';
    };

    recognition.onstart = () => {
      finalText = '';
      setListening(true);
    };

    recognition.onresult = (event) => {
      let interim = '';
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const transcript = event.results[i][0]?.transcript || '';
        if (event.results[i].isFinal) finalText += transcript;
        else interim += transcript;
      }
      const spoken = (finalText || interim).trim();
      if (spoken) input.value = spoken;
    };

    recognition.onerror = (event) => {
      setListening(false);
      if (event.error === 'not-allowed' || event.error === 'service-not-allowed') {
        status.textContent = 'Activa el permiso del micrófono en el navegador para usar la voz.';
      } else if (event.error === 'no-speech') {
        status.textContent = 'No he oído nada. Pulsa el micro y vuelve a hablar.';
      } else {
        status.textContent = 'No se ha podido usar el micrófono. Inténtalo de nuevo.';
      }
    };

    recognition.onend = () => {
      const shouldSubmit = finalText.trim().length > 0;
      setListening(false);
      if (shouldSubmit) {
        input.value = finalText.trim();
        status.textContent = 'Pregunta recibida por voz.';
        setTimeout(() => {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
          else submit.click();
        }, 180);
      }
    };

    mic.addEventListener('click', () => {
      if (listening) {
        recognition.stop();
        return;
      }
      try {
        recognition.start();
      } catch (_) {}
    });
  }

  function boot() {
    const existing = document.getElementById('cv-copilot-discover');
    if (existing) install(existing);

    const observer = new MutationObserver(() => {
      const root = document.getElementById('cv-copilot-discover');
      if (root) install(root);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();